<!--  -->
<template>
  <div>
    <van-nav-bar
      left-arrow
      fixed
      title="订单列表"
      @click-left="$router.go(-1)"
    />
    <div v-if="customerLogs.length > 0" v-cloak>
      <template v-for="(item, index) in customerLogs">
        <van-cell
          :key="index"
          v-if="item.order.status != 0"
          :title="'订单号:' + item.order.order"
          :label="'金额:' + item.order.final_price"
          is-link
          @click="$router.push('/TakeOrderDetail/' + item.order.id)"
        >
          <template #icon>
            <template v-if="item.order.status == 0">
              <van-icon name="static/img/OrderDelivery0.png" />
            </template>
            <template v-else>
              <van-icon name="static/img/OrderDelivery2.png" />
            </template>
          </template>
        </van-cell>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customerLogs: []
    };
  },
  created() {
    this.getCustomerLogs();
  },
  methods: {
    getCustomerLogs() {
      this.$axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/customerLog",
        data: {
          store_id: sessionStorage.actShopId,
          phone: this.$route.params.phone,
          type: 1
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            this.customerLogs = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("StaffList.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-field__left-icon .van-icon {
  font-size: 20px;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-cell__label {
  font-size: 16px;
}
/deep/ .van-tabs__line {
  background-color: #fd3f3f;
}
/deep/ .van-cell .van-icon {
  font-size: 24px;
}
/deep/ .van-cell__value {
  flex: none;
  color: #323233;
}

[v-cloak] {
  display: none !important;
}
.text {
  text-align: center;
  margin-top: 10%;
  font-size: 30px;
}
.wrap {
  background: #fff;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  padding: 10px 16px;
  line-height: 24px;
  border-bottom: 1px solid #eee;
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/Shop/CustomerList.vue